'use client';

import { createContext } from 'react';
import { TabsContextValue, TabsVariant } from 'types';

export const TabsContext = createContext<TabsContextValue>({
  selectedTabId: '',
  setSelectedTabId: () => {},
  variant: TabsVariant.NORMAL,
});
